import {lightGray} from '@modifi/colors'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${({theme}): string => theme?.backgroundColorLight};
  padding: 8px 16px 8px 16px;
`

export const SeparatorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

export const Separator = styled.span`
  width: 1px;
  background: ${lightGray};
  height: 100%;
  display: inline-block;
`
